/* Keep the existing shopping assistant clear of purchasing controls. */
(() => {
  const emit = (name, data = {}) => {
    const payload = {design_version:'cro-20261010-v3',device:matchMedia('(max-width:749px)').matches?'mobile':'desktop',...data};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:name,...payload});
    try {window.Shopify?.analytics?.publish(name,payload);} catch (_) { /* Purchase controls must remain usable. */ }
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') window.clarity('event',name.replace(':','_'));
  };
  const visibleSuggestions = new Set();
  let pendingSuggestion;
  const suggestionObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const card=entry.target;
      const key=card.dataset.ohmmSource+':'+card.dataset.ohmmVariant;
      if(entry.isIntersecting && !visibleSuggestions.has(key)){
        visibleSuggestions.add(key);
        emit('ohmm:cross_sell_view',{source:card.dataset.ohmmSource,product_handle:card.dataset.ohmmProduct,variant_id:card.dataset.ohmmVariant});
      }
    }
  },{threshold:.5});
  const syncSuggestions = () => {
    document.querySelectorAll('[data-ohmm-cross-sell]').forEach(card => {
      if(card.dataset.ohmmSource==='jewelry-page') card.hidden=!!document.querySelector(`[data-ohmm-cart-variant="${card.dataset.ohmmVariant}"]`);
      if(!card.dataset.ohmmObserved){card.dataset.ohmmObserved='true';suggestionObserver.observe(card);}
    });
    if(pendingSuggestion && document.querySelector(`[data-ohmm-cart-variant="${pendingSuggestion.variant_id}"]`)){
      emit('ohmm:cross_sell_added',pendingSuggestion);pendingSuggestion=undefined;
    }
  };
  let currentHost, currentShadow;
  const syncAssistant = () => {
    const host = document.getElementById('ads-agent-host');
    if (!host) return;
    if (host !== currentHost) currentHost = host;
    const drawerOpen = !!document.querySelector('cart-drawer.active,menu-drawer details[open]');
    const zoomOpen = !!document.querySelector('dialog[open]');
    host.toggleAttribute('data-ohmm-purchase-overlay', drawerOpen || zoomOpen);
    if (host.shadowRoot && currentShadow !== host.shadowRoot) {
      currentShadow = host.shadowRoot;
      const style = document.createElement('style');
      style.textContent = '[data-testid="entrypoint"]{left:auto!important;right:16px!important;bottom:18px!important;transform:none!important;margin:0!important}[data-testid="entrypoint"] [role="button"]{max-width:190px}@media(max-width:749px){[data-testid="entrypoint"]{bottom:92px!important;right:12px!important}[data-testid="entrypoint"] [role="button"]{max-width:52px;overflow:hidden}[data-testid="entrypoint"] [role="button"] .truncate{display:none}}';
      currentShadow.append(style);
    }
  };
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false; syncAssistant();syncSuggestions();});
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','open']});
  syncAssistant();
  syncSuggestions();
  document.addEventListener('click', event => {
    const link = event.target.closest('a.ohmm-size-link');
    if (link) {
      const details = document.getElementById(link.hash.slice(1));
      if (details?.tagName === 'DETAILS') details.open = true;
      emit('ohmm:size_guide_open',{product_handle:location.pathname.split('/products/')[1]||''});
    }
    const card=event.target.closest('[data-ohmm-cross-sell]');
    if(card && event.target.closest('button[type="submit"]') && !document.querySelector(`[data-ohmm-cart-variant="${card.dataset.ohmmVariant}"]`)) pendingSuggestion={source:card.dataset.ohmmSource,product_handle:card.dataset.ohmmProduct,variant_id:card.dataset.ohmmVariant};
  });
  document.addEventListener('shopify:section:load',syncAssistant);
})();
